// extracted by css-extract-rspack-plugin
export default {"launcher":"aF_M8","token":"gVuJG"};